/**
 * @file Header links toggle
 * 
 * @author Konrad Kaliszewski <kkaliszewski@squiz.pl>
 * @date March 2018
 */

var headerLinks = (function () {
    var $headerLinksToggle = $('.header-links__toggle');
    var $headerAddClass = $('#header-main');
    var $siteMenuLinksToggle = $('.header-site-menu__toggle');

    function toggleAriaExpanded() {
        var ariaExpanded = $headerLinksToggle.attr('aria-expanded');
        var expanded;
        switch (ariaExpanded) {
            case 'true': {
                expanded = true;
                $siteMenuLinksToggle.attr('aria-expanded', false);
                $headerAddClass.removeClass('header-wrapper__expanded');
                $headerAddClass.addClass('header-wrapper__hidden');
                break;
            }
            case 'false': {
                expanded = false;
                $siteMenuLinksToggle.attr('aria-expanded', false);
                $headerAddClass.addClass('header-wrapper__expanded');
                $headerAddClass.removeClass('header-wrapper__hidden');
                break;
            }
            default: {
                break;
            }
        }
        
        $headerLinksToggle.attr('aria-expanded', !expanded);
    }

    // Binds all the events
    function bind() {

        $headerLinksToggle.click(function() {
            toggleAriaExpanded();
        });
    }

    /**
     * Initialisation
     */
    return {
        init: function() {
            bind();
        }
    };
}());

(function() {
    headerLinks.init();
}(jQuery));


var siteMenuLinks = (function () {
    var $siteMenuLinksToggle = $('.header-site-menu__toggle');
    var $headerLinksToggle = $('.header-links__toggle');
    var $headerAddClass = $('#header-main');
    function toggleAriaExpanded() {
        var ariaExpanded = $siteMenuLinksToggle.attr('aria-expanded');
        var expanded;
        switch (ariaExpanded) {
            case 'true': {
                expanded = true;
                $headerLinksToggle.attr('aria-expanded', false);
                $headerAddClass.removeClass('header-wrapper__expanded');
                $headerAddClass.addClass('header-wrapper__hidden');

                break;
            }
            case 'false': {
                expanded = false;
                $headerLinksToggle.attr('aria-expanded', false);
                $headerAddClass.removeClass('header-wrapper__expanded');
                $headerAddClass.addClass('header-wrapper__hidden');
                break;
            }
            default: {
                break;
            }
        }
        
        $siteMenuLinksToggle.attr('aria-expanded', !expanded);
    }

    // Binds all the events
    function bind() {

        $siteMenuLinksToggle.click(function() {
            toggleAriaExpanded();
        });
    }

    /**
     * Initialisation
     */
    return {
        init: function() {
            bind();
        }
    };
}());

(function() {
    siteMenuLinks.init();
}(jQuery));